module.exports = __webpack_public_path__ + "img/ms.e147bd2b.svg";